export default __webpack_public_path__ + "static/media/8.c7377982.jpeg";